module.exports = __webpack_public_path__ + "img/heart.a11d2a14.svg";